import { call, fork, put, select, take } from 'redux-saga/effects';

// Actions
import * as actionsCreator from "./reducer";

// Store
import { RootState } from '../../store';
import { optionsPrices } from 'lib/helpers';

function* _select<T>(fn: (state: RootState) => T) {
	const res: T = yield select(fn);
	return res;
}

// Generic response
export type ApiResponse<Data extends unknown> = {
	data?: Data;
	ok?: boolean;
	status?: number;
};

export const settings = (store: RootState) => store.settings;

export function* pfizerSagaStart(api: any, action: any) {
	yield fork(getCategoriesWatcher, api, action);
	yield fork(getEbcCategoriesByIdWatcher, api, action);
};

/**
 *  get all ebc categories watcher Sagas starter
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getCategoriesWatcher(api: any, action: any) {
	while (true) {
		try {
			yield take(actionsCreator.getCategories.type);

			const res: ApiResponse<any> = yield call(api.request, "getAllEbcCategories");

			if (!res.ok) {
				yield put(actionsCreator.getCategoriesError());
			} else {
				yield put(actionsCreator.getCategoriesSuccess(res?.data?.children || []));
			}
		} catch (e) {
			console.log("CATCH ERROR: getCategoriesWatcher: ", e);
		}
	}
}

/**
 *  Get by id categories watcher Sagas starter
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getEbcCategoriesByIdWatcher(api: any, action: any): Generator<any, void, any> {
	while (true) {
		try {
			const actions = yield take(actionsCreator.getEbcCategoriesById.type);

			const res: ApiResponse<any> = yield call(api.request, "getEbcCategoriesById", actions.payload);

			if (!res.ok) {
				yield put(actionsCreator.getEbcCategoriesByIdError());
			} else {
				let countPrice = 0;
				const state = yield* _select(settings);
				let currentPrice = state.currentPrice;
				const priceApp = JSON.parse(localStorage.getItem("priceApp") || "{}");

				const formData = res.data?.length ? res.data.map((item: any) => {
					const optionsPr = item.prices?.length
						? item.prices.map((item: any) =>
							optionsPrices(item)
						) : [];

					optionsPr.forEach((item: any) => {
						if (!item.value) {
							countPrice += 1;
						}
						countPrice = 0;
					});

					const prices5 = item?.prices
						? item.prices
								.filter((supplier: any) => supplier.supplier === 'EBC')
								.flatMap((supplier: any) => supplier.prices.filter((price: any) => price.mg === 5))
						: [];

					return {
						...item,
						quantity: 1,
						selected: false,
						countPrice: countPrice,
						currentTypePrice: "EBC",
						px: item.px ? item.px : '',
						action: item.action ? item.action : '',
						isPOA: optionsPr.length === countPrice,
						currentPrice: Object.values(priceApp)?.length ? priceApp : { ...currentPrice, price: prices5.length ? prices5[0]?.priceUsd : [] },
					}
				}) : [];

				yield put(actionsCreator.getEbcCategoriesByIdSuccess(formData));
			}
		} catch (e) {
			console.log("CATCH ERROR: getEbcCategoriesByIdWatcher: ", e);
		}
	}
}
